export default "__VITE_ASSET__BewAV7G6__"